import { Outlet } from 'react-router-dom'

export const EmptyLayout = () => {
  return (
    <div>
      <Outlet />
    </div>
  )
}
